import ToolbarButton from './toolbar-button.vue'

ToolbarButton.install = function (Vue) {
  Vue.component(ToolbarButton.name, ToolbarButton)
}
export default ToolbarButton
